/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as RepoDefs from './defs.defs.js'

const $nsid = 'com.atproto.repo.applyWrites'

export { $nsid }

/** Apply a batch transaction of repository creates, updates, and deletes. Requires auth, implemented by PDS. */
const main = l.procedure(
  $nsid,
  l.params(),
  l.jsonPayload({
    repo: l.string({ format: 'at-identifier' }),
    validate: l.optional(l.boolean()),
    writes: l.array(
      l.typedUnion(
        [
          l.typedRef<Create>((() => create) as any),
          l.typedRef<Update>((() => update) as any),
          l.typedRef<Delete$0>((() => delete$0) as any),
        ],
        true,
      ),
    ),
    swapCommit: l.optional(l.string({ format: 'cid' })),
  }),
  l.jsonPayload({
    commit: l.optional(
      l.ref<RepoDefs.CommitMeta>((() => RepoDefs.commitMeta) as any),
    ),
    results: l.optional(
      l.array(
        l.typedUnion(
          [
            l.typedRef<CreateResult>((() => createResult) as any),
            l.typedRef<UpdateResult>((() => updateResult) as any),
            l.typedRef<DeleteResult>((() => deleteResult) as any),
          ],
          true,
        ),
      ),
    ),
  }),
  ['InvalidSwap'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Input<B = l.BinaryData> = l.InferMethodInput<typeof main, B>
export type $InputBody<B = l.BinaryData> = l.InferMethodInputBody<
  typeof main,
  B
>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $input = main.input,
  $output = main.output

/** Operation which creates a new record. */
type Create = {
  $type?: 'com.atproto.repo.applyWrites#create'
  collection: l.NsidString

  /**
   * NOTE: maxLength is redundant with record-key format. Keeping it temporarily to ensure backwards compatibility.
   */
  rkey?: l.RecordKeyString
  value: l.LexMap
}

export type { Create }

/** Operation which creates a new record. */
const create = l.typedObject<Create>(
  $nsid,
  'create',
  l.object({
    collection: l.string({ format: 'nsid' }),
    rkey: l.optional(l.string({ maxLength: 512, format: 'record-key' })),
    value: l.lexMap(),
  }),
)

export { create }

/** Operation which updates an existing record. */
type Update = {
  $type?: 'com.atproto.repo.applyWrites#update'
  collection: l.NsidString
  rkey: l.RecordKeyString
  value: l.LexMap
}

export type { Update }

/** Operation which updates an existing record. */
const update = l.typedObject<Update>(
  $nsid,
  'update',
  l.object({
    collection: l.string({ format: 'nsid' }),
    rkey: l.string({ format: 'record-key' }),
    value: l.lexMap(),
  }),
)

export { update }

/** Operation which deletes an existing record. */
type Delete$0 = {
  $type?: 'com.atproto.repo.applyWrites#delete'
  collection: l.NsidString
  rkey: l.RecordKeyString
}

export type { Delete$0 as Delete }

/** Operation which deletes an existing record. */
const delete$0 = l.typedObject<Delete$0>(
  $nsid,
  'delete',
  l.object({
    collection: l.string({ format: 'nsid' }),
    rkey: l.string({ format: 'record-key' }),
  }),
)

export { delete$0 as 'delete' }

type CreateResult = {
  $type?: 'com.atproto.repo.applyWrites#createResult'
  uri: l.AtUriString
  cid: l.CidString
  validationStatus?: 'valid' | 'unknown' | l.UnknownString
}

export type { CreateResult }

const createResult = l.typedObject<CreateResult>(
  $nsid,
  'createResult',
  l.object({
    uri: l.string({ format: 'at-uri' }),
    cid: l.string({ format: 'cid' }),
    validationStatus: l.optional(
      l.string<{ knownValues: ['valid', 'unknown'] }>(),
    ),
  }),
)

export { createResult }

type UpdateResult = {
  $type?: 'com.atproto.repo.applyWrites#updateResult'
  uri: l.AtUriString
  cid: l.CidString
  validationStatus?: 'valid' | 'unknown' | l.UnknownString
}

export type { UpdateResult }

const updateResult = l.typedObject<UpdateResult>(
  $nsid,
  'updateResult',
  l.object({
    uri: l.string({ format: 'at-uri' }),
    cid: l.string({ format: 'cid' }),
    validationStatus: l.optional(
      l.string<{ knownValues: ['valid', 'unknown'] }>(),
    ),
  }),
)

export { updateResult }

type DeleteResult = { $type?: 'com.atproto.repo.applyWrites#deleteResult' }

export type { DeleteResult }

const deleteResult = l.typedObject<DeleteResult>(
  $nsid,
  'deleteResult',
  l.object({}),
)

export { deleteResult }
